@if(isPageLoading){
  <app-activity-skeleton-loader></app-activity-skeleton-loader>
  }@else{
  
  <ng-container *ngIf="!isModal; else matCardTemplate">
    <div class="standalone-class">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </ng-container>
  
  <ng-template #matCardTemplate>
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
  </ng-template>
  
  <ng-template #contentTemplate>
    <h2  mat-dialog-title
     class="dialog-header"
     *ngIf="isModal && !isEmbedded">

  <span class="title-text">
    {{ dataInfo?.isReschedule ? 'Reschedule Activity'
                              : (editMode ? 'Edit' : 'Create') }} Activity
  </span>

  <button  mat-icon-button
           aria-label="Close"
           (click)="closeModal()"
           class="close-btn">
    <mat-icon>close</mat-icon>
  </button>
</h2>
  
    <!-- NEW: Remove mat-dialog-content wrapper and replace with dialog-body -->
    <mat-dialog-content 
      class="dialog-body" 
      [class.calendar-disabled]="dataInfo?.disableCalendar"
      [class.lead-view-mode]="inputData()?.leadView">
  
      <!-- LEFT PANE: Form Content -->
      <div class="left-pane" [class.full-width]="dataInfo.task || leftPaneFullWidth">
        @if(showToggleButton) {
          <div class="right-pane-toggle-container">
            <button mat-icon-button 
                    class="right-pane-toggle-btn"
                    [class.calendar-visible]="isCalendarVisible"
                    (click)="toggleRightPane()"
                    [matTooltip]="isCalendarVisible ? 'Hide Calendar' : 'Show Calendar'">
              <mat-icon>{{ isCalendarVisible ? 'chevron_right' : 'chevron_left' }}</mat-icon>
            </button>
          </div>
        }
        <div class="left-scroll">
          <div class="row">
            <div class="{{(!isModal && !dataInfo?.disableCalendar) ? 'col-md-12' : (detailed && !dataInfo.task && !dataInfo?.disableCalendar) ? 'col-md-12' : 'col-md-12'}}">
              <form [formGroup]="eventForm">
                <!-- Title -->
                <mat-form-field appearance="outline" class="w-100 title-field">
                  <mat-label>{{ !isTitleFocused && !eventForm.get('name')?.value ? (activity?.name || 'Title') : 'Title' }}</mat-label>
                  <input (focus)="onFocus()" (blur)="onBlur()" matInput formControlName="name"
                    placeholder="{{activity?.name || 'Title'}}" />
                </mat-form-field>
  
                <!-- Activity Types Toggle - Always shows all types -->
                <mat-button-toggle-group formControlName="type" name="eventType" aria-label="Event type selection"
                  (change)="getActivity($event)" class="type-field-activity"
                  [matTooltip]="isRecurring ? 'Activity type cannot be changed for recurring events' : ''"
                  [class.recurring-disabled]="isRecurring">
                  @for(activity of activityTypes; track activity.id){
                  <mat-button-toggle [value]="activity.id" [matTooltip]="isRecurring ? '' : activity?.name">
                    <mat-icon>{{ activity.icon }}</mat-icon>
                    @if(isEmbedded && activityTypes.length <7){
                      <span class="activity-name">{{activity?.name}}</span>
                    }
                    
                  </mat-button-toggle>
                  }
                </mat-button-toggle-group>
  
                @if(showSubcategories){
                <div class="subcategory-container">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Select Subcategory</mat-label>
                    <mat-select formControlName="subcategory" (selectionChange)="onSubcategoryChange($event)">
                      @for(subcategory of subcategories; track subcategory.id){
                      <mat-option [value]="subcategory.id">{{ subcategory.name }}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                }
                
                @if((editMode || eventForm.get('completed')?.value) && activity?.is_appointment){
                  <div class="attendance-chips">
                    <label class="attendance-label">Attendance Status:</label>
                    <mat-chip-listbox [value]="currentAttendanceStatus" #statusChips>
                      @for(status of attendanceStatuses; track status.value){
                        <mat-chip-option
                          [value]="status.value"
                          [color]="status.color"
                          [selected]="currentAttendanceStatus === status.value"
                          (selectionChange)="onAttendanceChipSelect($event, status.value)">
                          {{ status.label }}
                        </mat-chip-option>
                      }
                    </mat-chip-listbox>
                  </div>
                
                  @if(showOutcomeSelection && activityOutcomes.length > 0){
                    <div class="outcome-selection">
                      <mat-form-field appearance="outline" class="outcome-field">
                        <mat-label>{{ isOutcomeRequired() ? 'Outcome *' : 'Outcome' }}</mat-label>
                        <mat-select [value]="selectedOutcome" (selectionChange)="onOutcomeSelected($event.value)"
                          [required]="isOutcomeRequired()">
                          @for(outcome of activityOutcomes; track outcome.outcome.id){
                            <mat-option [value]="outcome.outcome.id">
                              {{ outcome.outcome.name }}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  }
                }
  
                <div class="row p-10">
                  <!-- Date Field - Updated with readonly condition -->
                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Date</mat-label>
                      <input matInput [matDatepicker]="picker" formControlName="startDate" [readonly]="isTimeReadOnly()" />
                      <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="isTimeReadOnly()"></mat-datepicker-toggle>
                      <mat-datepicker #picker [disabled]="isTimeReadOnly()"></mat-datepicker>
                    </mat-form-field>
                    <mat-error class="validation-error" *ngIf="eventForm.hasError('dateRangeInvalid')">
                      {{ eventForm.getError('dateRangeInvalid') }}
                    </mat-error>
                  </div>
  
                  <!-- Start Time Field -->
                  @if(!activity?.isTask){
                  <div class="col-md-3">
                    <app-time-picker label="Start Time" [control]="startTimeControl" [focusTime]="focusTime"
                      [readOnlyPicker]="isTimeReadOnly()" [showDefaultTime]="showDefaultTime" (cleared)="onStartTimeCleared()"></app-time-picker>
                    @if(eventForm?.errors && eventForm.errors['timeRangeInvalid'] && (startTimeControl.touched ||
                    endTimeControl.touched)){
                    <p class="validation-error">
                      Invalid Time
                    </p>
                    }
                  </div>
  
                  <div class="col-md-3">
                    <app-time-picker label="End Time" [focusTime]="endDateFocusTime" [showDefaultTime]="showDefaultTime" [control]="endTimeControl"
                      [readOnlyPicker]="isTimeReadOnly()" [hideClearButton]="true"></app-time-picker>
                    @if(eventForm?.errors && eventForm.errors['timeRangeInvalid'] && (startTimeControl.touched ||
                    endTimeControl.touched)){
                    <p class="validation-error">
                      Invalid Time
                    </p>
                    }
                  </div>
  
                  }@else{
                  <div class="col-md-6">
                    <mat-form-field appearance="outline" class="w-100">
                      <mat-label>Due Date</mat-label>
                      <input matInput [matDatepicker]="picker" formControlName="dueDate" [readonly]="isTimeReadOnly()" />
                      <mat-datepicker-toggle matSuffix [for]="picker" [disabled]="isTimeReadOnly()"></mat-datepicker-toggle>
                      <mat-datepicker #picker [disabled]="isTimeReadOnly()"></mat-datepicker>
                    </mat-form-field>
                  </div>
                  }
                </div>

                @if(detailed){
                @if(activity?.is_appointment){
                <!-- Campus/Virtual Mode Selection -->
                @if(appointmentMode === 'campus' && !showButton && !showMeeting){
                <div class="action-container">
                  <span class="campus-mode-text">Make it a Campus Appointment</span>
                  <span class="action-text">
                    or <a (click)="switchToVirtualMode()" class="action-link">add attendees, and video call</a>
                  </span>
                </div>
                }
  
                @if(appointmentMode === 'virtual' && !showMeeting){
                <div class="action-container">
                  <a (click)="switchToCampusMode()" class="action-link">← Back to Campus Appointment</a>
                </div>
                }
                }@else{
                <!-- Non-appointment logic (existing) -->
                @if(!showButton && !showMeeting){
                <div class="action-container">
                  <span class="action-text">
                    Add <a (click)="showMeetForm()" class="action-link">attendees</a>,
                    <a (click)="showMeetForm()" class="action-link">and video call</a>
                  </span>
                </div>
                }
                }
  
                <!-- Meeting Provider Menu (Pipedrive Style) -->
                @if(showButton && !showMeeting){
                <div class="meeting-menu-container">
                  <button class="meeting-menu-trigger" [matMenuTriggerFor]="meetingMenu" [disabled]="isLoading">
                    <div class="meeting-menu-content">
                      @if(!selectedProvider){
                        <mat-icon class="meeting-default-icon">videocam</mat-icon>
                        <span>Add attendees, and video call</span>
                      }@else{
                        @if(selectedProvider === 'google'){
                          <img src="/assets/images/svgs/google-icon.svg" class="meeting-provider-icon" alt="Google Meet">
                          <span>{{hasGoogleMeet ? 'Make it a Google Meet meeting' : 'Connect Google Meet'}}</span>
                        }
                        @if(selectedProvider === 'zoom'){
                          <img src="/assets/images/svgs/zoom-icon.svg" class="meeting-provider-icon" alt="Zoom">
                          <span>{{hasZoom ? 'Make it a Zoom meeting' : 'Connect Zoom'}}</span>
                        }
                      }
                      
                      @if(isLoading){
                        <mat-spinner diameter="16" class="loading-spinner"></mat-spinner>
                      }@else{
                        <mat-icon class="dropdown-arrow">keyboard_arrow_down</mat-icon>
                      }
                    </div>
                  </button>

                  <mat-menu #meetingMenu="matMenu">

                    <button mat-menu-item (click)="selectProvider('google')">
                      <img src="/assets/images/svgs/google-icon.svg"
                           style="width:20px; height:20px; margin-right:10px;" />
                      <span>Connect Google Meet</span>
                    </button>
                  
                    <button mat-menu-item (click)="selectProvider('zoom')">
                      <img src="/assets/images/svgs/zoom-icon.svg"
                           style="width:20px; height:20px; margin-right:10px;" />
                      <span>Connect Zoom</span>
                    </button>
                  
                  </mat-menu>
                </div>
                }
  
                @if(showMeeting){
                <div class="meeting-container" [class.google-meet-container]="selectedProvider === 'google'" [class.zoom-container]="selectedProvider === 'zoom'">
                  @if(activity?.is_appointment){
                  <div class="virtual-mode-header">
                    <span class="virtual-mode-text">Virtual Appointment</span>
                    <a (click)="switchToCampusMode()" class="switch-mode-link">Switch to Campus</a>
                  </div>
                  }
  
                  @if(showDefaultAttendees && !editMode){
                  <div class="action-container">
                    <span class="action-text">
                      Make attendees same as <a class="action-link" style="font-weight: bold;text-decoration: none;">owner and
                        lead</a> or
                      <a (click)="addAttendees()" class="action-link">select attendees</a>
                    </span>
                  </div>
                  } @else{
                  <app-custom-attendees-manager [label]="'Attendees'" [showEmailsOnly]="true"
                    [formControl]="$any(eventForm).get('attendees')" (valueSelected)="contactChange($event)">
                  </app-custom-attendees-manager>
                  }

                  <!-- Google Meet URL Field -->
                  @if(selectedProvider === 'google'){
                  <mat-form-field class="w-100 title-field" appearance="outline">
                    <mat-label>Google Meet URL</mat-label>
                    <input matInput formControlName="meetingLink" placeholder="Google Meet URL" />
                    <button mat-icon-button matSuffix aria-label="Copy" [matTooltip]="tooltipMessage"
                      #copyTooltip="matTooltip" (click)="copyMeetingLink(copyTooltip)">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    <button mat-icon-button (click)="removeMeeting()" matSuffix aria-label="Clear">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>

                  <div class="w-100">
                    <button mat-raised-button color="primary" (click)="joinMeet()" class="join-meeting-button">
                      Join Google Meet meeting
                    </button>
                  </div>
                  }

                  <!-- Zoom Meeting Fields -->
                  @if(selectedProvider === 'zoom'){
                  <!-- Meeting URL Display -->
                  <mat-form-field class="w-100 title-field" appearance="outline">
                    <mat-label>Zoom Meeting URL</mat-label>
                    <input matInput formControlName="zoomJoinUrl" placeholder="Zoom Meeting URL" readonly />
                    <button mat-icon-button matSuffix aria-label="Copy Meeting Info" [matTooltip]="tooltipMessage"
                      #copyTooltip="matTooltip" (click)="copyZoomMeetingInfo()">
                      <mat-icon>content_copy</mat-icon>
                    </button>
                    <button mat-icon-button (click)="removeMeeting()" matSuffix aria-label="Clear">
                      <mat-icon>close</mat-icon>
                    </button>
                  </mat-form-field>

                  <!-- Join Meeting Button -->
                  <div class="w-100 mb-3">
                    <button mat-raised-button color="primary" (click)="joinZoomMeeting()" class="join-meeting-button">
                      <mat-icon>videocam</mat-icon>
                      Join Zoom meeting
                    </button>
                  </div>

                  <!-- Meeting Details Container -->
                  <div class="zoom-meeting-details" *ngIf="zoomMeetingData">
                    <div class="meeting-info-section">
                      <p class="meeting-description">
                        {{eventForm.get('assignedToName')?.value || 'Host'}} is inviting you to a scheduled Zoom meeting.
                      </p>
                      
                      <div class="meeting-link-section">
                        <strong>Join Zoom Meeting</strong><br>
                        <a [href]="eventForm.get('zoomJoinUrl')?.value" target="_blank" class="zoom-link">
                          {{eventForm.get('zoomJoinUrl')?.value}}
                        </a>
                      </div>

                      @if(eventForm.get('zoomPassword')?.value){
                      <div class="meeting-detail">
                        <strong>Password:</strong> {{eventForm.get('zoomPassword')?.value}}
                      </div>
                      }

                      @if(eventForm.get('zoomMeetingId')?.value){
                      <div class="meeting-detail">
                        <strong>Meeting ID:</strong> {{eventForm.get('zoomMeetingId')?.value}}
                      </div>
                      }

                    </div>
                  </div>
                  }
                </div>
                }
  
                <!-- Replace the existing notes div section with this -->
                <div class="notes">
                  <app-html-editor [formControl]="$any(eventForm).get('notes')" [height]="'100px'" [showNoteBackground]="true"
                    placeholder="Notes" [quillModule]="quillModule" title="Notes"></app-html-editor>
  
                  <!-- Quick notes toggle button -->
                  <div class="quick-notes-toggle" (click)="toggleQuickNotes()">
                    <div class="toggle-content">
                      <mat-icon>{{ showQuickNotes ? 'expand_less' : 'expand_more' }}</mat-icon>
                      <span>Quick notes</span>
                      <mat-icon class="flash-icon">flash_on</mat-icon>
                    </div>
                  </div>
  
                  <!-- Expandable suggestions section -->
                  <div class="suggestions-tabs-container" *ngIf="showQuickNotes">
                    <div class="suggestions-tabs-wrapper">
                      <div class="suggestions-tabs" *ngIf="!loadingSuggestions && userNoteUsage.length > 0">
                        <div class="suggestions-tabs" *ngIf="!loadingSuggestions && userNoteUsage.length > 0">
                          <div class="suggestion-tab" 
                               *ngFor="let suggestion of userNoteUsage; let i = index"
                               (click)="insertSuggestion(suggestion)" 
                               [title]="suggestion.text">
                            <span class="tab-text">{{ suggestion.text }}</span>
                            <button class="remove-btn" (click)="removeSuggestion($event, suggestion)">
                              <mat-icon>close</mat-icon>
                            </button>
                          </div>
                        </div>
                      </div>
  
                      <div class="suggestions-loading-tabs" *ngIf="loadingSuggestions">
                        <div class="loading-tab" *ngFor="let item of [1,2,3]">
                          <span class="skeleton-text"></span>
                        </div>
                      </div>
  
                      <div class="no-suggestions" *ngIf="!loadingSuggestions && userNoteUsage.length === 0">
                        <span>No quick notes available</span>
                      </div>
                    </div>
                  </div>
                </div>

                @if(isGeneral && !activity?.isTask && !editMode){
                <app-recurrence-config [formControl]="$any(eventForm).get('recurrence')"></app-recurrence-config>
                }
                }

                @if(!isRecurring){
                <app-auto-complete [options]="leadOptions" [label]="'Lead Name'" [formControl]="$any(eventForm).get('lead')"
                  (valueSelected)="leadChange($event)" (valueChanged)="handleValueChanged($event)"
                  [enableDetailNavigation]="enableDetailNavigation"
  (optionClicked)="navigateToDetail($event)">
                </app-auto-complete>
                }
  
                @if(detailed){
                <app-select [options]="users" [displayKey]="'name'" [placeholder]="'Owner'" [required]="true"
                  formControlName="assignedTo">
                </app-select>
                }
  
                <!-- Campus Name -->
                @if(detailed){
                <app-select [options]="campuses" [displayKey]="'name'" [placeholder]="'Campus'" [required]="true"
                  formControlName="campus">
                </app-select>
                }
  
              </form>
            </div>
          </div>
        </div>
  
        <!-- LEFT ACTIONS - Pinned to bottom of left column -->
        <div class="left-actions">
          <div class="actions-left">
            <button mat-button (click)="closeModal()">Cancel</button>
            <mat-icon
              *ngIf="hasSettingsAccess"
              class="settings-icon"
              matTooltip="Configure activity types"
              matTooltipPosition="above"
              (click)="goToActivitiesSettings()">
              settings
            </mat-icon>
          </div>
  
          <div class="actions-right">
            @if(!detailed){
            <button mat-stroked-button (click)="details()">Details...</button>
            }
  
            <!-- Reschedule button for appointments -->
            @if(isModal && activity?.is_appointment && editMode){
            <button mat-stroked-button color="accent" (click)="rescheduleAppointment()">
              Reschedule
            </button>
            }
  
          
            <mat-checkbox [disabled]="(eventForm.errors?.['timeRangeInvalid'] && (startTimeControl.touched || endTimeControl.touched)) ||
                eventForm.errors?.['dateRangeInvalid']" [checked]="dataInfo.completed" (change)="onMarkAsDoneChange($event)">
              @if(dataInfo.completed){
              Marked
              }
              @else{
              Mark
              }
              as Done
            </mat-checkbox>
            <button mat-raised-button 
            color="primary" 
            [disabled]="!eventForm.dirty ||
                        (eventForm.errors?.['timeRangeInvalid'] && (startTimeControl.touched || endTimeControl.touched)) ||
                        eventForm.errors?.['dateRangeInvalid'] ||
                        isSaving ||
                        isLoading" 
            (click)="saveEvent()">
            <span *ngIf="!isSaving && !isLoading">Save</span>
            <span *ngIf="isSaving || isLoading" class="saving-state">
              <mat-spinner diameter="16" class="inline-spinner"></mat-spinner>
              Saving...
            </span>
          </button>
            
          </div>
        </div>
      </div>
  
      <!-- RIGHT PANE: Calendar (only show when detailed and calendar is enabled) -->
      @if(showRightPane){
      <div class="right-pane">
        <app-calendar [showCalendarMode]="false" [detailedInfo]="detailedInfo" [defaultView]="'day'" [hourSegments]="4"
          [dayStartHour]="9" [dayEndHour]="23" (calendarData)="calendarData($event)"></app-calendar>
          
         
      </div>

    }

      <!-- @if(showCalendarToggle) {
        <button mat-fab 
                class="calendar-toggle-right" 
                (click)="showCalendar()"
                color="primary"
                matTooltip="Show Calendar">
          <mat-icon>calendar_today</mat-icon>
        </button>
      } -->
      
      <!-- ADD MOBILE CALENDAR SLIDE PANEL (after the toggle button) -->
      <div *ngIf="isCalendarVisible" class="calendar-slide-panel" 
           [class.calendar-visible]="isCalendarVisible">
        <div class="calendar-header">
          <h3>Select Date & Time</h3>
          <div class="calendar-actions">
            <button mat-icon-button 
                    class="header-icon-button"
                    (click)="hideCalendar()"
                    matTooltip="Close Calendar">
              <mat-icon>close</mat-icon>
            </button>
          </div>
        </div>
        <div class="calendar-content">
          @if(isCalendarVisible) {
            <app-calendar 
              [showCalendarMode]="false" 
              [detailedInfo]="detailedInfo" 
              [defaultView]="'day'" 
              [hourSegments]="4"
              [dayStartHour]="9" 
              [dayEndHour]="23" 
              (calendarData)="onCalendarDataSelected($event)">
            </app-calendar>
          }
        </div>
      </div>
      
      <!-- ADD MOBILE OVERLAY (after the slide panel) -->
      <div class="form-overlay" 
           [class.overlay-visible]="isCalendarVisible"
           (click)="hideCalendar()">
      </div>

    
      
 
  
    </mat-dialog-content>
  </ng-template>
  }